import React from 'react';
import PropTypes from 'prop-types';

const Loading = ({ variant }) => (
  <div className="loading-programs">
    <div className={variant === 'inline' ? 'spinner--inline' : 'spinner'} />
  </div>
);

Loading.propTypes = {
  variant: PropTypes.oneOf(['fullscreen', 'inline']),
};

Loading.defaultProps = {
  variant: 'fullscreen',
};

export default Loading;
